export default __webpack_public_path__ + "static/media/Captain's Gauntlets of the Warring States.7e0cb54e.jpg";